import {
  type AppController,
  type SerializedPageStructure,
} from '@wix/document-services-types'

import {
  assertAppControllerData,
  assertNonNullable,
  modifyComponentByVeloId,
} from './utils'
import { FILTER_DATASET_VELO_ID } from './veloIds'

export const rebindFilterDataset = ({
  page,
  collectionId,
}: {
  page: SerializedPageStructure
  collectionId: string
}): SerializedPageStructure =>
  modifyComponentByVeloId({
    root: page,
    veloId: FILTER_DATASET_VELO_ID,
    modifyComponent: filterDataset => {
      assertNonNullable(filterDataset.data)
      assertAppControllerData(filterDataset.data)
      assertNonNullable(filterDataset.data.settings)
      const settings = JSON.parse(filterDataset.data.settings)
      const data: AppController = {
        ...filterDataset.data,
        settings: JSON.stringify({
          ...settings,
          dataset: { ...settings.dataset, collectionName: collectionId },
        }),
      }
      return { ...filterDataset, data }
    },
  })
